import React, { Component } from "react"

/* Widgets */
import Layout from "./widgets/Layout"

/* Components */
import { Notification } from "./components"


/* Entry Point */
class App extends Component {

    render = () => {

        return (
            <div className="main">
                <Layout />
                <Notification />
            </div>
        )

    }

}

export default App